import ArrowsIcon from 'assets/svg/icons/Arrows';
import BankIcon from 'assets/svg/icons/Bank';
import BriefcaseIcon from 'assets/svg/icons/Briefcase';
import CakeIcon from 'assets/svg/icons/Cake';
import CalculatorIcon from 'assets/svg/icons/Calculator';
import CalendarQuestionIcon from 'assets/svg/icons/CalendarQuestion';
import Camera2Icon from 'assets/svg/icons/Camera2';
import CarIcon from 'assets/svg/icons/Car';
import Car2Icon from 'assets/svg/icons/Car2';
import CarEngineIcon from 'assets/svg/icons/CarEngine';
import Checklist2Icon from 'assets/svg/icons/Checklist2';
import CoinsIcon from 'assets/svg/icons/Coins';
import CreditCardIcon from 'assets/svg/icons/CreditCard';
import FileEuroIcon from 'assets/svg/icons/FileEuro';
import FileImportantIcon from 'assets/svg/icons/FileImportant';
import FileSearch2Icon from 'assets/svg/icons/FileSearch2';
import FileUserIcon from 'assets/svg/icons/FileUser';
import ForkIcon from 'assets/svg/icons/Fork';
import Fork2Icon from 'assets/svg/icons/Fork2';
import GridMasonry2Icon from 'assets/svg/icons/GridMasonry2';
import HealthIcon from 'assets/svg/icons/Health';
import Home2Icon from 'assets/svg/icons/Home2';
import LaptopAndPhoneIcon from 'assets/svg/icons/LaptopAndPhone';
import LeaderboardIcon from 'assets/svg/icons/Leaderboard';
import LightBulbIcon from 'assets/svg/icons/LightBulb';
import LinkIcon from 'assets/svg/icons/Link';
import MailOpenCrossIcon from 'assets/svg/icons/MailOpenCross';
import MoneyBagIcon from 'assets/svg/icons/MoneyBag';
import MoneyPercentageIcon from 'assets/svg/icons/MoneyPercentage';
import MoneyPlusIcon from 'assets/svg/icons/MoneyPlus';
import MoneyReceiveIcon from 'assets/svg/icons/MoneyReceive';
import MoneyReceive2Icon from 'assets/svg/icons/MoneyReceive2';
import NewspaperIcon from 'assets/svg/icons/Newspaper';
import PeppolIcon from 'assets/svg/icons/PeppolIcon';
import PiggybankIcon from 'assets/svg/icons/Piggybank';
import QuestionMarkCircleIcon from 'assets/svg/icons/QuestionMarkCircle';
import ReceiveMoneyIcon from 'assets/svg/icons/ReceiveMoney';
import Send2Icon from 'assets/svg/icons/Send2';
import ShareIcon from 'assets/svg/icons/Share';
import TableColumnsIcon from 'assets/svg/icons/TableColumns';
import TaxIcon from 'assets/svg/icons/Tax';
import TopHatIcon from 'assets/svg/icons/TopHat';
import TruckIcon from 'assets/svg/icons/Truck';
import UmbrellaIcon from 'assets/svg/icons/Umbrella';
import UndoIcon from 'assets/svg/icons/undo';
import UpstairsIcon from 'assets/svg/icons/Upstairs';
import cn from 'classnames';
import HelpIcon from 'components/atoms/SVG/sidebarIcons/Help.component';
import TaxesIcon from 'components/atoms/SVG/sidebarIcons/TaxesIcon.component';
import type { ComponentType } from 'react';
import { SuggestedQuestion } from 'types/ai.types';

const IconsMap: Record<SuggestedQuestion['icon'], ComponentType<any>> = {
  'calendar-question': CalendarQuestionIcon,
  'camera-2': Camera2Icon,
  'car-2': Car2Icon,
  'car-engine': CarEngineIcon,
  'checklist-2': Checklist2Icon,
  'credit-card': CreditCardIcon,
  'file-euro': FileEuroIcon,
  'file-important': FileImportantIcon,
  'file-search-2': FileSearch2Icon,
  'file-user': FileUserIcon,
  'fork-2': Fork2Icon,
  'grid-masonry-2': GridMasonry2Icon,
  'home-2': Home2Icon,
  'laptop-and-phone': LaptopAndPhoneIcon,
  'light-bulb': LightBulbIcon,
  'mail-open-cross': MailOpenCrossIcon,
  'money-bag': MoneyBagIcon,
  'money-percentage': MoneyPercentageIcon,
  'money-plus': MoneyPlusIcon,
  'money-receive-2': MoneyReceive2Icon,
  'money-receive': MoneyReceiveIcon,
  'question-mark-circle': QuestionMarkCircleIcon,
  'receive-money': ReceiveMoneyIcon,
  'send-2': Send2Icon,
  'table-columns': TableColumnsIcon,
  arrows: ArrowsIcon,
  bank: BankIcon,
  briefcase: BriefcaseIcon,
  cake: CakeIcon,
  calculator: CalculatorIcon,
  car: CarIcon,
  coins: CoinsIcon,
  fork: ForkIcon,
  health: HealthIcon,
  help: HelpIcon,
  leaderboard: LeaderboardIcon,
  link: LinkIcon,
  newspaper: NewspaperIcon,
  peppol: PeppolIcon,
  piggybank: PiggybankIcon,
  scale: TaxesIcon,
  share: ShareIcon,
  tax: TaxIcon,
  tophat: TopHatIcon,
  truck: TruckIcon,
  umbrella: UmbrellaIcon,
  undo: UndoIcon,
  upstairs: UpstairsIcon,
} as const;

const textColorsMap: Record<SuggestedQuestion['color'], string> = {
  expenses: 'text-expenses',
  taxes: 'text-taxes',
  bank: 'text-bank',
  revenues: 'text-revenues',
};

type SuggestedQuestionIconProps = {
  icon: SuggestedQuestion['icon'];
  color: SuggestedQuestion['color'];
};

const SuggestedQuestionIcon = ({ icon, color }: SuggestedQuestionIconProps) => {
  const Icon = IconsMap[icon] || IconsMap.scale;
  const textColor = textColorsMap[color];

  return <Icon className={cn('flex-shrink-0 h-6 w-6', textColor)} />;
};

export default SuggestedQuestionIcon;
